import { useState } from 'react';

const useVariableSensitivity = (initialState = '') => {
  const [variableSensitivity, setVariableSensitivity] = useState(initialState);

  const changeVariableSensitivity = (value) => {
    setVariableSensitivity(value);
  };

  return [variableSensitivity, changeVariableSensitivity];
};

export default useVariableSensitivity;
